import React from "react";

import {
    Card,
    Empty,
    List,
    Tag,
    Typography
} from "antd";

import {
    InboxOutlined
} from "@ant-design/icons";

const {
    Text,
    Title
} = Typography;


const ArchivedNotificationList = ({
                                      notifications = []
                                  }) => {

    const archivedNotifications =
        notifications.filter(
            notification =>
                notification.archived === true ||
                notification.status === "ARCHIVED"
        );

    if (!archivedNotifications.length) {
        return (
            <Empty
                description="Aucune notification archivée"
            />
        );
    }

    return (
        <List
            dataSource={archivedNotifications}
            rowKey={notification => notification.id}
            renderItem={notification => (

                <List.Item>

                    <Card
                        style={{
                            width: "100%",
                            borderRadius: 12,
                            opacity: 0.8
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent:
                                    "space-between",
                                alignItems:
                                    "flex-start",
                                gap: 16
                            }}
                        >

                            <div>

                                <Title
                                    level={5}
                                >
                                    <InboxOutlined />
                                    {" "}
                                    {notification.title ||
                                        "Notification archivée"}
                                </Title>

                                <Text>
                                    {notification.message}
                                </Text>

                            </div>

                            <Tag>
                                ARCHIVÉE
                            </Tag>

                        </div>

                        {notification.createdAt && (

                            <div
                                style={{
                                    marginTop: 8
                                }}
                            >

                                <Text
                                    type="secondary"
                                >
                                    {new Date(
                                        notification.createdAt
                                    ).toLocaleString(
                                        "fr-FR"
                                    )}
                                </Text>

                            </div>

                        )}

                    </Card>

                </List.Item>

            )}
        />
    );
};

export default ArchivedNotificationList;